import { FetchError } from '@atlassian/jira-fetch/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RestIssueType } from '../../services/jira/types.tsx';
import type { IssueTypeWithPinnedFields } from '../types.tsx';

export const transformIssueTypeResponse = (rest: RestIssueType): IssueTypeWithPinnedFields => ({
	id: String(rest.id),
	name: rest.name,
	entityId: rest.entityId,
	description: rest.description,
	avatarId: String(rest.avatarId),
	hierarchyLevel: rest.hierarchyLevel,
	operation: {
		deletable: rest.operation.deletable,
		editable: rest.operation.editable,
	},
	pinnedFields: fg('jpd-types-pinned-fields') ? rest.pinnedFields : undefined,
});

export const isUpdatingRemovedIssueTypeError = (errorObject: unknown): boolean =>
	errorObject instanceof FetchError && errorObject.statusCode === 412;
